// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q9-EH","title":"styles_title__ZhD0L","subTitle":"styles_subTitle__nOkt0"};